var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.855,
    height: 38.179,
    viewBox: "0 0 128.855 38.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.b{fill:#a6a5a5;}.c{fill:#010101;}.d{opacity:0.1;}.e{fill:url(#a);}.f{fill:url(#b);}.g{fill:url(#c);}.h{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.993,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#267caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#4a92b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#79bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.638,
    y1: 0.141,
    x2: 0.339,
    y2: 0.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#f5907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#fbb777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.866,
    y1: 0.172,
    x2: 0.048,
    y2: 1.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#d94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#af487a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#954b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.106,
    y1: 0.073,
    x2: 0.888,
    y2: 0.85,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde79a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M284.943,337.425a3.657,3.657,0,0,1-3.658,3.657H161.459a3.662,3.662,0,0,1-3.666-3.657V308.264a3.667,3.667,0,0,1,3.666-3.661H281.281a3.661,3.661,0,0,1,3.661,3.66h0v29.161Z",
    transform: "translate(-156.943 -303.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.084,336.735H156.261a4.517,4.517,0,0,1-4.516-4.507v-29.16a4.519,4.519,0,0,1,4.516-4.512H276.083a4.521,4.521,0,0,1,4.516,4.512v29.16a4.516,4.516,0,0,1-4.515,4.507Z",
    transform: "translate(-151.745 -298.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M284.943,337.425a3.657,3.657,0,0,1-3.658,3.657H161.459a3.662,3.662,0,0,1-3.666-3.657V308.264a3.667,3.667,0,0,1,3.666-3.661H281.281a3.661,3.661,0,0,1,3.661,3.66h0v29.161Z",
    transform: "translate(-156.943 -303.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M644.008,298.556H579.827l25.138,38.179h39.042a4.519,4.519,0,0,0,4.516-4.51V303.068A4.52,4.52,0,0,0,644.008,298.556Z",
    transform: "translate(-519.669 -298.556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.494 7.441)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M441.495,361.85a2.543,2.543,0,0,1-.653,1.867,2.9,2.9,0,1,1-2.053-4.946,2.484,2.484,0,0,1,1.12.28,2.031,2.031,0,0,1,.84.653l-.467.467a1.74,1.74,0,0,0-1.493-.653,1.857,1.857,0,0,0-1.493.653,2.253,2.253,0,0,0,0,3.173,2.4,2.4,0,0,0,1.493.653,2.046,2.046,0,0,0,1.586-.653,1.545,1.545,0,0,0,.467-1.12h-2.053v-.747h2.707v.373Zm4.293-2.333h-2.52v1.773H445.6v.653h-2.333v1.773h2.52v.746h-3.266v-5.6h3.266Zm3.08,4.946h-.747v-4.946h-1.587v-.653h3.92v.653h-1.587Zm4.293,0v-5.6h.746v5.6Zm3.92,0h-.747v-4.946h-1.587v-.653h3.826v.653h-1.586v4.946Zm8.866-.746a2.929,2.929,0,1,1,.84-2.053A2.744,2.744,0,0,1,465.946,363.716Zm-3.546-.467a2.2,2.2,0,0,0,1.493.653,1.856,1.856,0,0,0,1.493-.653,2.251,2.251,0,0,0,.653-1.587,1.922,1.922,0,0,0-.653-1.586,2.2,2.2,0,0,0-1.493-.653,1.857,1.857,0,0,0-1.493.653,2.251,2.251,0,0,0-.653,1.586A1.923,1.923,0,0,0,462.4,363.25Zm5.413,1.213v-5.6h.84l2.706,4.386v-4.386h.747v5.6h-.747l-2.893-4.573v4.573Z",
    transform: "translate(-409.458 -357.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M459.1,422.256a3.926,3.926,0,0,0-4.013,4.013,3.983,3.983,0,0,0,4.013,4.013,3.926,3.926,0,0,0,4.013-4.013A3.872,3.872,0,0,0,459.1,422.256Zm0,6.346a2.434,2.434,0,0,1,0-4.853,2.261,2.261,0,0,1,2.24,2.426A2.317,2.317,0,0,1,459.1,428.6Zm-8.679-6.346a3.926,3.926,0,0,0-4.013,4.013,3.983,3.983,0,0,0,4.013,4.013,3.926,3.926,0,0,0,4.013-4.013A3.872,3.872,0,0,0,450.421,422.256Zm0,6.346a2.434,2.434,0,0,1,0-4.853,2.261,2.261,0,0,1,2.24,2.426A2.317,2.317,0,0,1,450.421,428.6Zm-10.359-5.133v1.68h4.013a3.528,3.528,0,0,1-.933,2.146,4.13,4.13,0,0,1-3.08,1.213,4.345,4.345,0,0,1-4.386-4.48,4.4,4.4,0,0,1,4.386-4.48,4.628,4.628,0,0,1,3.08,1.213l1.213-1.213a5.98,5.98,0,0,0-4.2-1.68,6.16,6.16,0,1,0,0,12.319,5.37,5.37,0,0,0,4.293-1.773,5.618,5.618,0,0,0,1.493-3.92,3.5,3.5,0,0,0-.093-1.027Zm42.37,1.307a3.626,3.626,0,0,0-3.36-2.52,3.759,3.759,0,0,0-3.733,4.013,3.905,3.905,0,0,0,3.92,4.013,3.828,3.828,0,0,0,3.266-1.773l-1.307-.933a2.275,2.275,0,0,1-1.96,1.12,2.025,2.025,0,0,1-1.96-1.213l5.32-2.24-.187-.467Zm-5.413,1.307a2.267,2.267,0,0,1,2.053-2.333,1.651,1.651,0,0,1,1.493.84l-3.546,1.493Zm-4.386,3.826h1.773V418.243h-1.773Zm-2.8-6.813a3.072,3.072,0,0,0-2.147-.933,4.01,4.01,0,0,0-3.826,4.013,3.864,3.864,0,0,0,3.826,3.92,2.679,2.679,0,0,0,2.053-.933h.093v.56a2.122,2.122,0,0,1-4.106.933l-1.493.653a3.85,3.85,0,0,0,3.546,2.333c2.053,0,3.733-1.213,3.733-4.106v-7.093h-1.68v.653Zm-2.053,5.506a2.434,2.434,0,0,1,0-4.853,2.445,2.445,0,0,1,0,4.853Zm22.771-10.359h-4.2v11.666h1.773v-4.386h2.426a3.644,3.644,0,1,0,0-7.279Zm.093,5.6h-2.52V419.83h2.52a2.05,2.05,0,0,1,2.053,1.96,2.136,2.136,0,0,1-2.053,2.053Zm10.733-1.68a3.137,3.137,0,0,0-3.08,1.773l1.587.653a1.649,1.649,0,0,1,1.587-.84,1.754,1.754,0,0,1,1.866,1.493v.093a3.7,3.7,0,0,0-1.773-.467c-1.68,0-3.36.933-3.36,2.613A2.734,2.734,0,0,0,501.1,430.1a2.626,2.626,0,0,0,2.24-1.12h.093v.933h1.68v-4.48a3.532,3.532,0,0,0-3.733-3.266Zm-.187,6.439c-.56,0-1.4-.28-1.4-1.027,0-.933,1.027-1.213,1.867-1.213a3.6,3.6,0,0,1,1.586.373A2.173,2.173,0,0,1,501.189,428.6Zm9.8-6.159-1.96,5.039h-.093l-2.053-5.039h-1.867l3.08,7.093-1.773,3.92H508.1l4.759-11.012Zm-15.679,7.466h1.773V418.243H495.31Z",
    transform: "translate(-407.745 -408.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M248.144,353.686a1.825,1.825,0,0,0-.373,1.307v20.625a1.846,1.846,0,0,0,.467,1.307l.093.093L259.9,365.445v-.187Z",
    transform: "translate(-247.771 -353.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M337.265,416.739l-3.826-3.826v-.28l3.826-3.826.093.093,4.573,2.613c1.306.747,1.306,1.96,0,2.706Z",
    transform: "translate(-321.4 -400.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M266.012,440.618l-3.92-3.92-11.666,11.666c.467.466,1.12.466,1.96.093l13.625-7.839",
    transform: "translate(-250.054 -424.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M266.012,359.556l-13.625-7.746a1.513,1.513,0,0,0-1.96.093l11.666,11.572,3.92-3.92Z",
    transform: "translate(-250.054 -351.503)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.00500f4b153c9aea0f81fa9cfd33b397.svg";
export { ForwardRef as ReactComponent };